import React from "react";
import ContentPageTemplate from "../components/ContentPageTemplate";
import { costPages } from "../data/costPages";

export default function BrandingKostenOesterreich() {
  return <ContentPageTemplate {...costPages.branding} />;
}
